export default __webpack_public_path__ + "static/media/Layer 1.a191019d.png";